import React from 'react'
import {
  Icon,
  Message
} from 'semantic-ui-react'
import { format } from 'date-fns'
// Local
import {
  ENCOUNTER,
  FORMAT,
  shouldRenderReskin2025
} from '../../../constant'
import {
  Encounter,
  EncounterDetail
} from '../../authenticated/types'
import { Patient } from '../../patient/patient'
import If from '../../common/if'
import ReveleerCoachingBox from '../../ReveleerCoachingBox'

type Props = {
  encounterDetail: EncounterDetail
}

function PatientSnapshotWarning(
  props: Props
): JSX.Element | null {
  const { encounterDetail } = props

  const previousEncounter = (startDt: number | Date): boolean => {
    const today = parseInt(format(new Date(), 'YYYYMMDD'), 10)
    const start = parseInt(format(startDt, 'YYYYMMDD'), 10)
    return start < today
  }

  // const futureEncounter = (startDt: number | Date): boolean => {
  //   const today = parseInt(format(new Date(), 'YYYYMMDD'), 10)
  //   const start = parseInt(format(startDt, 'YYYYMMDD'), 10)
  //   return start > today
  // }

  const proposedEncounter = (encounter: Encounter): boolean => (
    encounter.status === ENCOUNTER.STATUS.PROPOSED
  )

  const proposedText = 'The content of this snapshot is based on the most current' +
    ' clinical and claims data available to the Curation platform.'

  const previousText = (encounter: Encounter): string => {
    const startDt = encounter && encounter.start
    if (startDt) {
      return 'The content of this snapshot is based on the last seen' +
        ` encounter for this patient, date: ${format(startDt, FORMAT.DATE_TIME)}.`
    }
    return ''
  }

  // const futureText = (encounter: Encounter): string => {
  //   const startDt = encounter && encounter.start
  //   if (startDt) {
  //     return 'The content of this snapshot is based on the next known' +
  //       ` encounter for this patient, date: ${format(startDt, FORMAT.DATE_TIME)}.`
  //   }
  //   return ''
  // }

  const messageContent = (
    encounter: Encounter | undefined,
    patient: Patient | undefined
  ): string => {
    if (patient && patient.firstName) {
      const firstName = patient.firstName.toUpperCase()
      const lastName = patient.lastName && patient.lastName.toUpperCase()
      const pre = `You are viewing a patient snapshot for patient: ${firstName} ${lastName}.`

      if (encounter && proposedEncounter(encounter)) {
        return `${pre} ${proposedText}`
      }
      if (encounter && encounter.start && previousEncounter(encounter.start)) {
        return `${pre} ${previousText(encounter)}`
        // Shawn This doesn't make sense !!!!!!!!!!!!!!!!!!!!!!!!!
        // } if (encounter && futureEncounter(encounter)) {
        //   return `${pre  } ${  futureText(encounter)}`
        // } 
        return pre
      }
    }
    return ''
  }

  const shouldRenderMessage = (
    encounterDetail &&
    encounterDetail.encounter &&
    encounterDetail.encounter.patient
  )

  if (shouldRenderMessage) {
    return (
      <>
        <If isTrue={ !shouldRenderReskin2025 }>
          <Message warning>
            <Icon name="warning circle" />
            <span>
              {
                messageContent(
                  encounterDetail.encounter,
                  encounterDetail.encounter && encounterDetail.encounter.patient
                )
              }
            </span>
          </Message>
        </If>
        <If isTrue={ shouldRenderReskin2025 }>
          <ReveleerCoachingBox
            coachingBoxType="infoNegative"
            isShowing
            message={
              <p>
                {
                  messageContent(
                    encounterDetail.encounter,
                    encounterDetail.encounter && encounterDetail.encounter.patient
                  )
                }
              </p>
            }
          />
        </If>
      </>
    )
  }
  return null
}

export default PatientSnapshotWarning
